"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsContext = exports.StepsPanel = exports.Steps = void 0;
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var Steps_1 = __importStar(require("./Steps"));
Object.defineProperty(exports, "StepsContext", {
  enumerable: true,
  get: function get() {
    return Steps_1.StepsContext;
  }
});
var StepsPanel_1 = __importDefault(require("./StepsPanel"));
exports.Steps = Steps_1["default"];
exports.StepsPanel = StepsPanel_1["default"];
(0, spaui_utils_1.setComponentMark)(exports.Steps, info_1["default"]);
(0, spaui_utils_1.setComponentMark)(exports.StepsPanel, info_1["default"]);
exports["default"] = {
  Steps: exports.Steps,
  StepsPanel: exports.StepsPanel,
  StepsContext: Steps_1.StepsContext
};